//
import Model from '../../models/Model'

/**
 * @description
 * This class describes a hr employee ic quote.
 *
 * @class      HrEmployeeIcQuote (name)
 */
export default class HrEmployeeIcQuote extends Model {

	/**
	 * @description
	 * { property_description }
	 *
	 * @type       {<type>}
	 */
	get period() {
		return `${this.period_year}-${this.period_month}`
	}

	/**
	 * @description
	 * { function_description }
	 *
	 * @return     {string}  { description_of_the_return_value }
	 */
    resource() {
        return 'hr_employee_ic_quote'
    }
}